import { useMemo } from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import { palette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { trTR } from '@mui/x-date-pickers/locales';
import { trTR as coreTrTR } from '@mui/material/locale';
import { dataGridOverrides } from './datagrid-overrides';
import { INPUT_FONT_SIZE } from '../utils/global-values';

export default function ThemeProvider({ children }) {
  const memoizedValue = useMemo(
    () => ({
      breakpoints: breakpoints,
      palette: palette(),
      typography: typography,
      components: {
        ...dataGridOverrides,
        MuiTextField: {
          styleOverrides: {
            root: {
              '& .MuiInputBase-input': {
                fontSize: INPUT_FONT_SIZE,
                lineHeight: 1.8,
                fontWeight: 400,
              },
            },
          },
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              fontSize: '0.9375rem',
            },
          },
        },
      },
    }),
    []
  );

  const theme = createTheme(memoizedValue, trTR, coreTrTR);


  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
